var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{attrs:{"id":"invalid-token"}},[_c('navbar',{attrs:{"title":"パスワード再設定の反映"}}),_c('background',[_c('div',{staticClass:"label-area"},[_c('p',{staticClass:"title"},[_vm._v("パスワード再設定リンクエラー")]),_c('p',[_vm._v("有効期限が切れています。"),_c('br'),_vm._v("再度パスワードの再設定リクエストからお試しください。")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }